import React from 'react';
import SVGInline from "react-svg-inline";
import mainLogoSVG from "../inlineSVGs/mainLogoSVG";


import './TopBarClean.css';

const TopBarClean = () =>  {
    const renderTitle = () =>{
        return (
            <div className="mugics-title" onClick={() => window.history.back()}>
                <SVGInline svg={mainLogoSVG} component="i"/>
            </div>
        )
    };

    return (
        <div className="top-bar-clean-wrapper">
            {renderTitle()}
        </div>
    )
};

export default TopBarClean;



// WEBPACK FOOTER //
// ./src/Components/Main/TopBarClean.js